import { connect } from 'react-redux'
import { setTabActive } from 'reduxpath/ducks/Project/Detail'

import TabMenu from './units'

const mapStateToProps = state => ({
  tabMenu: state.ProjectDetail.tabMenu,
  tabActive: state.ProjectDetail.tabActive,
})

const mapDispatchToProps = dispatch => ({
  setTabActive: idTab => () => {
    dispatch(setTabActive(idTab))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(TabMenu)
